module.exports = __webpack_public_path__ + "img/2_208.c4d1a28d.png";